var SCM = SCM || {};
SCM.ImageDescriptionToggle = (function ($) {
    // CONTRACT: these selectors, the img-desc-panel-{rid} id and the icon classes must match the markup
    // emitted by the XSLT `image-description-toggle` template (PresentationXSLT functions/_shared.functions.xslt)
    // and by C# ImageDescriptionToggleMarkup.Build (Core/SharedControls/Services/ImageLongDescription). Change all three together.
    // The back-matter selectors are bound to the section headings and jump links emitted by
    // Article/ArticleFulltext.SectionHead.cshtml, Article/ArticleJumpLinks.cshtml (Theme and the OUP override),
    // Content/BookSectionsText.TitleAndHtml.cshtml (top-level chapter headings carry the section-type-- class
    // from BookContentCustomizer.CustomizeBookSectionCssClass instead of the -title class) and Content/BookJumpLinks.cshtml.
    var PANEL_SELECTOR = '.js-image-description-panel';
    var TOGGLE_SELECTOR = '.js-image-description-toggle';
    var TOGGLE_ICON_SELECTOR = '.js-image-description-toggle-icon';
    var OBJECT_HEADING_SELECTOR = '.longdescriptionobject-title';
    var CONTAINER_HEADING_SELECTOR = '.longdescriptions-title, .section-type--longdescriptions';
    var JUMP_LINK_ITEM_SELECTOR = 'li.section-jump-link';
    var JUMP_LOCATION_SELECTOR = '.jumpLoc-sectionId';
    // The legacy-id anchors the views leave beside a description's heading (Content/BookSectionsText.cshtml,
    // Article/ArticleFulltext.cshtml); once the description is in its panel they duplicate its id.
    var LEGACY_JUMP_LOCATION_SELECTOR = '.jumpLoc-legacySectionId, a.legacy-id';
    var DESCRIPTION_TITLE_SELECTOR = '> .sec > .title';
    var TOGGLE_LABEL = 'Image description';
    var ICON_COLLAPSED_CLASS = 'icon-general-arrow-filled-down';
    var ICON_EXPANDED_CLASS = 'icon-general-arrow-filled-up';
    var PANEL_ID_PREFIX = 'img-desc-panel-';
    var ID_REFERENCE_ATTRIBUTES = ['href', 'headers', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'for'];
    var ID_REFERENCE_SELECTOR = '[' + ID_REFERENCE_ATTRIBUTES.join('],[') + ']';
    var isToggleClickHandlerBound = false;
    // Page-scoped on purpose, never reset per init(): a description left in the back matter by a failed
    // relocation would otherwise be taken for an unreferenced one by a later init() (abstract loads) and removed.
    var relocationFailureCount = 0;

    return {
        init: init,
        hasPanels: hasPanels,
        findPanelHoldingDescription: findPanelHoldingDescription,
        findToggle: findToggle
    };

    function init($scope) {
        var $root = $scope && $scope.length ? $scope : $(document);
        var $panels = $root.find(PANEL_SELECTOR);
        if (!$panels.length) {
            return;
        }

        _bindToggleClickHandler();

        var panelCountsByRid = {};
        $panels.each(function () {
            var $panel = $(this);
            _renumberAndDedupePanelForRid($panel, panelCountsByRid);
            _wirePanel($panel);
        });

        try {
            _suppressBackMatter($root);
        } catch (error) {
            window.console && console.error('Image description back matter suppression failed', error);
        }
    }

    function hasPanels() {
        return $(PANEL_SELECTOR).length > 0;
    }

    function findPanelHoldingDescription(rid) {
        var description = rid ? document.getElementById(rid) : null;

        return description ? $(description).closest(PANEL_SELECTOR) : $();
    }

    function findToggle($panel) {
        return $panel.prev(TOGGLE_SELECTOR);
    }

    function _bindToggleClickHandler() {
        if (isToggleClickHandlerBound) {
            return;
        }
        isToggleClickHandlerBound = true;

        $(document.body).on('click', TOGGLE_SELECTOR, function (event) {
            var $button = $(this);
            var $panel = $('#' + $button.attr('aria-controls'));
            var expand = $button.attr('aria-expanded') !== 'true';

            // Every client's own contentModals closes the in-place figure popup on any click that reaches body.
            event.stopPropagation();
            $button.attr('aria-expanded', expand ? 'true' : 'false');
            $panel.prop('hidden', !expand);
            _setIconState($button, expand);
        });
    }

    function _setIconState($button, expanded) {
        $button.find(TOGGLE_ICON_SELECTOR)
            .toggleClass(ICON_COLLAPSED_CLASS, !expanded)
            .toggleClass(ICON_EXPANDED_CLASS, expanded);
    }

    function _wirePanel($panel) {
        if ($panel.data('image-description-wired')) {
            return false;
        }

        var $button = $panel.prev(TOGGLE_SELECTOR);
        var arrivedPopulated = $panel.children().length > 0;

        if (!arrivedPopulated && !_relocateLongDescription($panel)) {
            relocationFailureCount++;
            $button.remove();
            $panel.remove();
            return false;
        }

        $panel.data('image-description-wired', true);
        _nameButtonAfterDescription($button, $panel);
        $button.removeAttr('hidden');
        return true;
    }

    function _nameButtonAfterDescription($button, $panel) {
        var title = $.trim($panel.find(DESCRIPTION_TITLE_SELECTOR).first().text());
        if (title) {
            $button.attr('aria-label', TOGGLE_LABEL + ': ' + title);
        }
    }

    function _renumberAndDedupePanelForRid($panel, panelCountsByRid) {
        var rid = $panel.data('long-desc-rid');
        if (rid === undefined || rid === '') {
            return;
        }

        panelCountsByRid[rid] = (panelCountsByRid[rid] || 0) + 1;
        var ridOccurrence = panelCountsByRid[rid];
        var panelId = PANEL_ID_PREFIX + rid + (ridOccurrence > 1 ? '-' + ridOccurrence : '');

        if ($panel.attr('id') === panelId) {
            return;
        }

        var previousSuffix = _occurrenceSuffix($panel);
        $panel.attr('id', panelId);
        $panel.prev(TOGGLE_SELECTOR).attr('aria-controls', panelId);

        var $children = $panel.children();
        if (ridOccurrence > 1 && $children.length > 0) {
            _suffixDescriptionIds($children, _occurrenceSuffix($panel), previousSuffix);
        }
    }

    function _occurrenceSuffix($panel) {
        var unsuffixedId = PANEL_ID_PREFIX + $panel.data('long-desc-rid');
        var id = $panel.attr('id') || '';

        return id.indexOf(unsuffixedId) === 0 ? id.slice(unsuffixedId.length) : '';
    }

    function _relocateLongDescription($panel) {
        var rid = $panel.data('long-desc-rid');
        var $description = _findDescriptionElement(rid);

        if (!$description.length) {
            return false;
        }

        var $alreadyRelocatedPanel = $description.closest(PANEL_SELECTOR);
        if ($alreadyRelocatedPanel.length) {
            var $clones = $alreadyRelocatedPanel.children().clone();
            _suffixDescriptionIds($clones, _occurrenceSuffix($panel));
            $panel.append($clones);
            return true;
        }

        var $sectionHead = _findObjectHeading(rid);

        $panel.append($description);
        _removeHeadingAndItsWrapper($sectionHead, true);
        return true;
    }

    function _findObjectHeading(rid) {
        return $(OBJECT_HEADING_SELECTOR + '[data-legacyid="' + rid + '"], ' +
            OBJECT_HEADING_SELECTOR + '[data-legacy-id="' + rid + '"]').first();
    }

    function _findDescriptionElement(rid) {
        var matchesRid = function () {
            return this.id === rid;
        };

        var $sectionHead = _findObjectHeading(rid);
        if ($sectionHead.length) {
            var $inWrapper = $sectionHead.next().find('section.sec').filter(matchesRid).first();
            if ($inWrapper.length) {
                return $inWrapper;
            }
        }

        // Chapters also emit a jumpLoc span with the same id as the description section, so the
        // fallback selects section elements only and never resolves the rid by bare id.
        return $('section.sec').filter(matchesRid).first();
    }

    function _suffixDescriptionIds($descriptionElements, suffix, previousSuffix) {
        var renamedIds = {};

        $descriptionElements.find('[id]').addBack('[id]').each(function () {
            renamedIds[this.id] = _stripSuffix(this.id, previousSuffix) + suffix;
            this.id = renamedIds[this.id];
        });

        $descriptionElements.find(ID_REFERENCE_SELECTOR).addBack(ID_REFERENCE_SELECTOR).each(function () {
            _rewriteIdReferences(this, renamedIds);
        });
    }

    function _stripSuffix(id, suffix) {
        var endsWithSuffix = suffix && id.length > suffix.length && id.slice(-suffix.length) === suffix;

        return endsWithSuffix ? id.slice(0, -suffix.length) : id;
    }

    function _rewriteIdReferences(element, renamedIds) {
        $.each(ID_REFERENCE_ATTRIBUTES, function (_, attribute) {
            var value = element.getAttribute(attribute);
            if (!value) {
                return;
            }
            var rewritten = $.map(value.split(/\s+/), function (token) {
                var isFragment = token.charAt(0) === '#';
                var id = isFragment ? token.substring(1) : token;
                return renamedIds[id] ? (isFragment ? '#' : '') + renamedIds[id] : token;
            }).join(' ');
            if (rewritten !== value) {
                element.setAttribute(attribute, rewritten);
            }
        });
    }

    // NARN-24340. Runs once every panel is wired, so whatever description heading is still in the back
    // matter is one no image referenced (BR603: it does not display). Skipped when any relocation failed:
    // a description a panel could not claim must stay reachable under its heading.
    function _suppressBackMatter($root) {
        if (relocationFailureCount > 0) {
            return;
        }

        _removeLegacyJumpLocationsOfRelocatedDescriptions($root);
        _removeUnclaimedDescriptions($root);
        _removeContainerHeadingsAndJumpLinks($root);
    }

    function _removeLegacyJumpLocationsOfRelocatedDescriptions($root) {
        $root.find(PANEL_SELECTOR).children('[id]').each(function () {
            var relocatedId = this.id;

            $root.find(LEGACY_JUMP_LOCATION_SELECTOR).filter(function () {
                return this.id === relocatedId;
            }).remove();
        });
    }

    function _removeUnclaimedDescriptions($root) {
        $root.find(OBJECT_HEADING_SELECTOR).each(function () {
            var $heading = $(this);
            var rid = $heading.attr('data-legacyid') || $heading.attr('data-legacy-id');

            // No id means the XML gave the description none (BR599 warns and loads it anyway), so it is
            // unreachable rather than unreferenced: removing it would take content only this page shows.
            if (!rid || _isClaimedByPanel(rid)) {
                return;
            }
            _removeHeadingAndItsWrapper($heading, false);
        });
    }

    function _isClaimedByPanel(rid) {
        return $(PANEL_SELECTOR).filter(function () {
            return this.getAttribute('data-long-desc-rid') === rid;
        }).length > 0;
    }

    function _removeContainerHeadingsAndJumpLinks($root) {
        $root.find(CONTAINER_HEADING_SELECTOR).each(function () {
            var $heading = $(this);
            var targetId = $heading.attr('id') || $heading.attr('data-magellan-destination');

            if (targetId) {
                $root.find(JUMP_LINK_ITEM_SELECTOR).filter(function () {
                    return $(this).find('a').filter(function () {
                        return this.getAttribute('href') === '#' + targetId;
                    }).length > 0;
                }).remove();
                $root.find(JUMP_LOCATION_SELECTOR).filter(function () {
                    return this.id === targetId;
                }).remove();
            }
            _removeHeadingAndItsWrapper($heading, true);
        });
    }

    function _removeHeadingAndItsWrapper($heading, requireEmptyWrapper) {
        var $wrapper = $heading.next();

        $heading.remove();
        if (_isSectionContentWrapper($wrapper) && (!requireEmptyWrapper || !$wrapper.text().trim())) {
            $wrapper.remove();
        }
    }

    // The element after a section heading is that section's content (the description's own markup,
    // or the empty wrapper the views leave for a container). Anything else, a heading or an unrelated
    // block with media or scripts in it, is not ours to remove.
    function _isSectionContentWrapper($element) {
        return $element.length > 0 &&
            $element.is('div, section') &&
            !$element.find('img, iframe, video, audio, object, embed, svg, canvas, script, form, input, button, select, textarea').length;
    }
})(jQuery);
